/* eslint-disable react/jsx-filename-extension */
import { ThemeProvider } from '@emotion/react';
import { RouterProvider } from 'react-router-dom';
import routes from './routes';
import { theme } from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={routes} />
    </ThemeProvider>
  );
}

export default App;
